import { Platform } from "react-native";
import { auth as webAuth, app as webApp } from "./firebaseAuthWeb";
import mobileAuth from "./firebaseAuthNative";

const auth = Platform.OS === "web" ? webAuth : mobileAuth;
const app = Platform.OS === "web" ? webApp : null;

export default auth;
export { app }; // always exported for web usage
